var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3983 5.13843C11.8173 5.13843 12.9675 3.98815 12.9675 2.56922C12.9675 1.15028 11.8173 0 10.3983 0C8.97938 0 7.8291 1.15028 7.8291 2.56922C7.8291 3.98815 8.97938 5.13843 10.3983 5.13843Z",
    fill: "#8A90A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68383 7.0654C5.82142 7.0654 6.74363 6.1432 6.74363 5.0056C6.74363 3.86801 5.82142 2.9458 4.68383 2.9458C3.54623 2.9458 2.62402 3.86801 2.62402 5.0056C2.62402 6.1432 3.54623 7.0654 4.68383 7.0654Z",
    fill: "#8A90A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38093 12.6022C3.37175 12.6022 4.17496 11.799 4.17496 10.8082C4.17496 9.81737 3.37175 9.01416 2.38093 9.01416C1.39012 9.01416 0.586914 9.81737 0.586914 10.8082C0.586914 11.799 1.39012 12.6022 2.38093 12.6022Z",
    fill: "#8A90A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83969 17.9181C5.61032 17.9181 6.23503 17.2934 6.23503 16.5228C6.23503 15.7522 5.61032 15.1274 4.83969 15.1274C4.06906 15.1274 3.44434 15.7522 3.44434 16.5228C3.44434 17.2934 4.06906 17.9181 4.83969 17.9181Z",
    fill: "#8A90A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5987 20.0001C11.247 20.0001 11.7725 19.4745 11.7725 18.8262C11.7725 18.1779 11.247 17.6523 10.5987 17.6523C9.95036 17.6523 9.4248 18.1779 9.4248 18.8262C9.4248 19.4745 9.95036 20.0001 10.5987 20.0001Z",
    fill: "#8A90A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2905 17.187C16.7676 17.187 17.1543 16.8003 17.1543 16.3233C17.1543 15.8462 16.7676 15.4595 16.2905 15.4595C15.8135 15.4595 15.4268 15.8462 15.4268 16.3233C15.4268 16.8003 15.8135 17.187 16.2905 17.187Z",
    fill: "#8A90A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7039 11.3623C19.0953 11.3623 19.4126 11.045 19.4126 10.6536C19.4126 10.2621 19.0953 9.94482 18.7039 9.94482C18.3124 9.94482 17.9951 10.2621 17.9951 10.6536C17.9951 11.045 18.3124 11.3623 18.7039 11.3623Z",
    fill: "#8A90A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionLoading);
export default __webpack_public_path__ + "static/media/option-loading.d82e964d93e73f735a42117f3857eff4.svg";
export { ForwardRef as ReactComponent };